<script lang="ts" setup>
import { getError } from '@autobid/strapi-integration/utils/getError'
import { useDebounce } from '@autobid/ui/composables/useDebounce'

interface Props {
  index: string // what should be searched
}

const props = defineProps<Props>()
const emits = defineEmits(['search', 'error'])
const { $trpc } = useNuxtApp()
const searchQuery = ref('')
const { locale } = useI18n()
const push = usePush()

const handleSearch = useDebounce(async () => {
  if (!searchQuery.value.length) {
    emits('search', {
      results: [],
    })
    return
  }

  try {
    const data = await $trpc.meilisearch.getSearchResults.query({ index: props.index, locale: locale.value, q: searchQuery.value })

    emits('search', data)
  }
  catch (error) {
    const { message, handled } = getError(error)

    if (!handled) {
      push.error(message)
    }

    emits('error')
  }
})
</script>

<template>
  <input v-model="searchQuery" type="text" @input="handleSearch">
</template>
